<template>
    <div :id="uid" v-if="fieldData.length" style="border-radius: 5px; background: #fff; position: relative;">
        <el-tooltip v-if="!hideEditButton" style="position: absolute; right: 20px; top:20px; z-index: 100;" :content="formMode == 'view' ? 'Edit' : 'View'" placement="top-start">
            <el-button v-if="formMode == 'view' " @click.stop="toggleformMode" size="mini" class="d-flex justify-content-center align-items-center" style="border-radius: 999px; height: 30px; width: 30px;">
                <fa v-if="formMode == 'view' " :icon="['fas', 'pen']" />
                <!-- <fa v-else :icon="['fas', 'eye']" /> -->
            </el-button>
        </el-tooltip>
        <p style="color: gray;">Additional Information</p>
        <el-form @submit.prevent.stop="">
            <div v-for="field in fieldData">
                <template>
                    <div v-if="field.type === 'calendar' && (field.publicView || user._id)">
                        <label style="color: #606266; font-size: 14px; padding: 15px 0 5px 0;" for="">{{ field.title }} <span v-if="!user._id && field.requiredForExternal">*</span></label>
                        <p class="text-danger" v-if="error.includes(field._id)">This field is required</p>
                        <el-date-picker
                            v-if="formMode == 'edit'"
                            @change="handleChange"
                            v-model="field.value"
                            :disabled="!user._id && !field.publicEditable"
                        />
                        <p v-else>
                            {{ field.value ? field.value : 'NA' }}
                        </p>
                    </div>
                    <div v-if="field.type === 'checkboxes' && (field.publicView || user._id)">
                        <label style="color: #606266; font-size: 14px; padding: 15px 0 5px 0;" for="">{{ field.title }} <span v-if="!user._id && field.requiredForExternal">*</span></label>
                        <p class="text-danger" v-if="error.includes(field._id)">This field is required</p>
                        <el-checkbox-group class="align-item-checkbox"
                            v-if="formMode == 'edit'"
                            v-model="field.value"
                            :disabled="!user._id && !field.publicEditable"
                            @change="handleChange"
                            >
                                <el-checkbox
                                    v-for="(value, index) in field.values.split('\n')"
                                    :checked="false"
                                    :label="value">
                                        {{ field.labels.split('\n')[index] }}
                                </el-checkbox>
                        </el-checkbox-group>
                        <p v-else>
                            {{ field.value ? field.value : 'NA' }}
                        </p>
                    </div>
                    <div v-if="field.type === 'list' && (field.publicView || user._id)">
                        <label style="color: #606266; font-size: 14px; padding: 15px 0 5px 0;" for="">{{ field.title }} <span v-if="!user._id && field.requiredForExternal">*</span></label>
                        <p class="text-danger" v-if="error.includes(field._id)">This field is required</p>
                        <div v-if="formMode == 'edit'" >
                            <el-select
                                v-model="field.value"
                                :disabled="!user._id && !field.publicEditable"
                                @change="handleChange"
                                >
                                    <el-option
                                        v-for="(value, index) in field.values.split('\n')"
                                        :value="value"
                                        :label="field.labels.split('\n')[index]"/>
                            </el-select>
                        </div>
                        <p v-else>
                            {{ field.value ? field.value : 'NA' }}
                        </p>
                    </div>
                    <div v-if="field.type === 'radio' && (field.publicView || user._id)">
                        <label style="color: #606266; font-size: 14px; padding: 15px 0 5px 0;" for="">{{ field.title }} <span v-if="!user._id && field.requiredForExternal">*</span></label>
                        <p class="text-danger" v-if="error.includes(field._id)">This field is required</p>
                        <div v-if="formMode == 'edit'" >
                            <el-radio
                                v-for="(value, index) in field.values.split('\n')"
                                    v-model="field.value"
                                :disabled="!user._id && !field.publicEditable"
                                :label="value"
                                @change="handleChange"
                            >
                                {{ field.labels.split('\n')[index] }}
                            </el-radio>
                        </div>
                        <p v-else>
                            {{ field.value ? field.labels.split('\n')[field.values.split('\n').indexOf(field.value)] : 'NA' }}
                        </p>
                    </div>
                    <div v-if="field.type === 'color' && (field.publicView || user._id)">
                        <label style="color: #606266; font-size: 14px; padding: 15px 0 5px 0;" for="">{{ field.title }} <span v-if="!user._id && field.requiredForExternal">*</span></label>
                        <p class="text-danger" v-if="error.includes(field._id)">This field is required</p>
                        <el-color-picker
                            @change="handleChange"
                            v-if="formMode == 'edit'"
                                v-model="field.value"
                            :disabled="!user._id && !field.publicEditable"
                        />
                        <p v-else>
                            {{ field.value ? field.value : 'NA' }}
                        </p>
                    </div>
                    <div v-if="field.type === 'integer' && (field.publicView || user._id)">
                        <label style="color: #606266; font-size: 14px; padding: 15px 0 5px 0;" for="">{{ field.title }} <span v-if="!user._id && field.requiredForExternal">*</span></label>
                        <p class="text-danger" v-if="error.includes(field._id)">This field is required</p>
                        <el-input
                            @change="handleChange"
                            v-if="formMode == 'edit'"
                            v-model="field.value"
                            :disabled="!user._id && !field.publicEditable"
                            type="number"
                        />
                        <p v-else>
                            {{ field.value ? field.value : 'NA' }}
                        </p>
                    </div>
                    <div v-if="field.type === 'text' && (field.publicView || user._id)">
                        <label style="color: #606266; font-size: 14px; padding: 15px 0 5px 0;" for="">{{ field.title }} <span v-if="!user._id && field.requiredForExternal">*</span></label>
                        <p class="text-danger" v-if="error.includes(field._id)">This field is required</p>
                        <el-input
                            :style="error.includes(field._id) ? 'border: 0.5px solid red; border-radius:4px;' : ''"
                            v-if="formMode == 'edit'"
                            v-model="field.value"
                            :disabled="!user._id && !field.publicEditable"
                            @change="handleChange"
                        >
                        </el-input>
                        <p v-else>
                            {{ field.value ? field.value : 'NA' }}
                        </p>
                    </div>

                    <div v-if="field.type === 'textarea' && (field.publicView || user._id)">
                        <label style="color: #606266; font-size: 14px; padding: 15px 0 5px 0;" for="">{{ field.title }} <span v-if="!user._id && field.requiredForExternal">*</span></label>
                        <p class="text-danger" v-if="error.includes(field._id)">This field is required</p>
                        <el-input
                            :style="error.includes(field._id) ? 'border: 0.5px solid red; border-radius:4px;' : ''"
                            v-if="formMode == 'edit'"
                            v-model="field.value"
                            :disabled="!user._id && !field.publicEditable"
                            @change="handleChange"
                            type="textarea"
                        />
                        <p v-else>
                            {{ field.value ? field.value : 'NA' }}
                        </p>
                    </div>
                    <div v-if="field.type === 'editor' && (field.publicView || user._id)">
                        <label style="color: #606266; font-size: 14px; padding: 15px 0 5px 0;" for="">{{ field.title }} <span v-if="!user._id && field.requiredForExternal">*</span></label>
                        <p class="text-danger" v-if="error.includes(field._id)">This field is required</p>
                        <quill-editor
                            v-if="formMode == 'edit'"
                            v-model="field.value"
                            :disabled="!user._id && !field.publicEditable"
                            @change="handleChange"
                        />
                        <div v-html="field.value" class="quill-editor" v-else></div>
                    </div>
                </template>
            </div>
        </el-form>
    </div>
</template>

<script>
import { v4 } from "uuid"
import { mapState } from 'vuex';

export default {
    props:{
        fields:{
            required: true,
            type: Array,
            default: () => []
        },
        registration:{
            type: Object,
            required: false
        },
        mode:{
            type: String,
            default: "view",
            validate: val => ["view", "edit"].includes(val)
        },
        hideEditButton:{
            type: Boolean,
            default: false
        },
        noClickOutsideDetection:{
            type: Boolean,
            default: false
        },
        revert: Boolean,
        error: {
            type: Array,
            default: () => []
        }
    },
    computed:{
        ...mapState(['user'])
    },
    data(){
        return {
            fieldData: [],
            formMode: "view",
            uid: null,
            reverted: false,
            firstName: "",
            lastName: ""
        }
    },
    watch:{
        fields(nv){
            this.fieldData = []
            nv.forEach(f => {
                let field = { ...f }
                this.fieldData.push(field);
            })
        },
        mode(nv){
            this.formMode = nv;
        },
        revert(nv){
            if(nv){
                this.fieldData = []
                this.fields.forEach(f => {
                    let field = { ...f }
                    this.fieldData.push(field);
                })
            }
        }
    },
    async mounted(){
        this.formMode = this.mode
        this.uid = 'form' + v4();
        this.fields.forEach(f => {
            let field = { ...f }
            this.fieldData.push(field);
        })

        this.handleChange()

        document.body.addEventListener('click', e =>{
            const root = document.querySelector('#' + this.uid);
            if(root && !root.contains(e.target)){
              if(!this.noClickOutsideDetection) this.formMode = "view";
            }
        })
    },
    methods:{
        toggleformMode(){
            this.formMode = this.formMode == "edit" ? "view" : "edit";
        },
        populateName(){
            if(this.registration){
                if(this.firstName || this.lastName) return;
                let fname = this.registration.fields.find(field => field.fieldMapping === 'firstName')
                let lname = this.registration.fields.find(field => field.fieldMapping === 'lastName')
                this.firstName = fname.value;
                this.lastName = lname.value;
            }
        },
        handleChange(){
            if(!this.registration) return;
            this.populateName()
            let obj = {}
            obj.registration = { _id: this.registration._id, confirmationNumber: this.registration.confirmationNumber, firstName: this.firstName, lastName: this.lastName };
            obj.fields = this.fieldData
            this.$emit('change', obj);
        }
    }

}
</script>

<style scoped>

</style>